import classNames from "classnames";
import styled from "styled-components";
import { TableLoadingRow } from "../../../components/tables/VirtualTable";

const TableCell = styled.td`
    width: ${({ width }) => width}%;
    max-width: 50px;
    vertical-align: middle;
`;

export const ClientManagementRow = ({ columns, data, index, style, isLoading }) => {
    const { height } = style;

    // Return nothing if we're loading data - the VirtualTable component handles that
    if (isLoading)
        return <></>;
    
    // Return a loading row when the data for this row in particular has not yet been collected from the backend
    if (index >= data.length)
        return <TableLoadingRow height={height} />;

    return <tr index={index} style={{ height }}>
        {columns.map((col, colIndex) =>
            <TableCell width={col.width} key={`row-col-${colIndex}`} className={classNames(col.className, "text-truncate")}>
                {col.CellComponent
                    ? <col.CellComponent
                        key={`row-col-${colIndex}`}
                        value={data[index]?.[col.property]}
                        index={index}
                        row={data[index]}
                        {...col}
                    />
                    : col.cellFormatter
                        ? col.cellFormatter(data[index]?.[col.property])
                        : data[index]?.[col.property]}
            </TableCell>)}
    </tr>;
};